import { css } from 'twin.macro';

import React, { useEffect, useState, Fragment } from 'react';
import { useForm } from 'react-hook-form';
import { Form, Modal } from 'react-bootstrap';

//Icons
import { FaEdit } from 'react-icons/fa';
import ID from '@/_helpers/uuid';
import { ModalFormContainer } from '../../smartpdf/styles';
import { customCheckbox } from '@/_elements/CustomCheckbox';
import WidgetFieldOptions from './WidgetFieldOptions';
import DraggableOptions from '../DraggableOptions';
import { prepareFieldProperties } from '../utils';

const FormElementEdit = (props) => {
    const [options, setOptions] = useState([]);
    const [isRequired, setIsRequired] = useState(true);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    useEffect(() => {
        setIsRequired(props.element.hasOwnProperty('required') ? props.element.required : true);
        if (
            props.element.key === 'Radio' ||
            props.element.key === 'Checkbox' ||
            props.element.key === 'Select' ||
            props.element.key === 'InputField' ||
            props.element.key === 'DatePicker'
        ) {
            if (props.element.data) {
                setOptions([...props.element.data]);
            }
        }
    }, [props.element]);

    const { register, handleSubmit } = useForm({
        mode: 'onBlur',
    });

    const onSubmit = (data) => {
        const tempData = { ...props.element };

        tempData.fieldName = data.fieldName;
        tempData.instruction = data.instruction;
        tempData.data = tempData?.data || {};
        if (data.url) tempData.data = { url: data.url };
        if (data.required) {
            tempData.required = true;
        } else {
            tempData.required = false;
        }
        if (
            props.element.key === 'Radio' ||
            props.element.key === 'Checkbox' ||
            props.element.key === 'Select' ||
            props.element.key === 'InputField' ||
            props.element.key === 'DatePicker'
        ) {
            tempData.data = options || [];
        }
        tempData.options = prepareFieldProperties(data);
        tempData.value = '';
        props.onEdit(tempData);
        handleClose();
    };

    const handleNewOption = (_newOption) => {
        let newOption = {
            value: ID.uuid(),
            text: `option ${options.length + 1}`,
        };

        setOptions((prev) => {
            return [...prev, newOption];
        });
    };

    const handleRemoveOption = (optionId) => {
        const tempData = [...options];
        const index = tempData.findIndex((option) => option.value === optionId);
        if (index !== -1) {
            tempData.splice(index, 1);
            setOptions(tempData);
        }
    };

    const handleOptionEdit = (e, optionId) => {
        const tempData = [...options];
        const index = tempData.findIndex((option) => option.value === optionId);
        if (index !== -1) {
            tempData[index].text = e.target.value;
            setOptions(tempData);
        }
    };

    const toggleIsRequired = () => {
        setIsRequired((prevIsRequired) => !prevIsRequired);
    };

    return (
        <Fragment>
            <span onClick={handleShow} className="pointer">
                <FaEdit color={props?.color || 'blue'} />
            </span>
            <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered size="xl">
                <ModalFormContainer>
                    <Modal.Body className=" position-relative">
                        <div
                            className="form-element filter"
                            css={css`
                                margin-bottom: 5px;
                                padding: 1rem 0.5rem 1rem 1rem;
                            `}
                        >
                            <Form>
                                <Form.Group controlId="formDescription">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Title"
                                        defaultValue={props.element.fieldName}
                                        name="fieldName"
                                        ref={register}
                                    />
                                </Form.Group>

                                <Form.Group controlId="formDescription">
                                    <Form.Label>Instruction</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        placeholder="instruction"
                                        defaultValue={props.element.instruction}
                                        name="instruction"
                                        ref={register}
                                    />
                                </Form.Group>

                                {props.element.key === 'Header' ||
                                props.element.key === 'PageBreak' ||
                                props.element.key === 'Paragraph' ||
                                props.element.key === 'Link' ||
                                props.element.key === 'PdfPreviewer' ||
                                props.element.key === 'Photo' ? null : (
                                    <Form.Group
                                        controlId="Isrequired"
                                        css={css`
                                            display: flex;
                                            align-items: center;
                                            .requiredCheckbox {
                                                width: 20px;
                                                height: 20px;
                                            }
                                        `}
                                    >
                                        <Form.Control
                                            className="requiredCheckbox"
                                            type="checkbox"
                                            css={customCheckbox}
                                            value={isRequired}
                                            checked={isRequired}
                                            onChange={toggleIsRequired}
                                            name="required"
                                            ref={register}
                                        />
                                        <Form.Label
                                            css={css`
                                                margin: 0;
                                            `}
                                        >
                                            Required
                                        </Form.Label>
                                    </Form.Group>
                                )}

                                <WidgetFieldOptions element={props.element} register={register} />

                                {(props.element.key === 'Radio' ||
                                    props.element.key === 'Checkbox' ||
                                    props.element.key === 'Select') && (
                                    <DraggableOptions
                                        element={props.element}
                                        register={register}
                                        options={options}
                                        setOptions={setOptions}
                                        handleOptionEdit={handleOptionEdit}
                                        handleRemoveOption={handleRemoveOption}
                                        handleNewOption={handleNewOption}
                                    />
                                )}
                            </Form>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-between">
                        <button className="btn button-orange" variant="secondary" onClick={handleClose}>
                            Close
                        </button>
                        <button className="btn button-green" type="btn" onClick={handleSubmit(onSubmit)}>
                            Done
                        </button>
                    </Modal.Footer>
                </ModalFormContainer>
            </Modal>
        </Fragment>
    );
};
export default FormElementEdit;
